import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
// import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { devicesActions, mapStateTypesActions } from "./store";
import HomeCollectionViewMt from "./HomeCollectionViewMt";
import { useEffectAsync } from "./reactHelper";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import AcUnitIcon from "@material-ui/icons/AcUnit";
import Chip from "@material-ui/core/Chip";
import FilterListView from "./FilterListView";
import ChartComp from "./PieChart";
import InfiniteScroll from "react-infinite-scroller";

import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { CircularProgress, Typography } from "@material-ui/core";

import {
  formatDistance,
  formatHours,
  formatDate,
  formatSpeed,
  formatVolume,
  formatPosition,
  formatDurationTime,
} from "./common/formatter";
import { useAttributePreference } from "./common/preferences";
import FaceIcon from "@material-ui/icons/Face";
import FavoriteIcon from "@material-ui/icons/Favorite";
import DriveEtaIcon from "@material-ui/icons/DriveEta";
import Divider from "@material-ui/core/Divider";
import SpeedIcon from "@material-ui/icons/Speed";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import BatteryStdIcon from "@material-ui/icons/BatteryStd";
import Grid from "@material-ui/core/Grid";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import t from "./common/localization";
import { Button, Paper } from "@material-ui/core";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import Fab from "@material-ui/core/Fab";
import ShareIcon from '@material-ui/icons/Share';
import SendIcon from "@material-ui/icons/Send";
import LockIcon from "@material-ui/icons/Lock";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import LocalParkingIcon from "@material-ui/icons/LocalParking";
const ShareLocationData = [
  {
    time: "60",
    label: "1 Hour",
  },
  {
    time: "1440",
    label: "1 Day",
  },
  {
    time: "10080",
    label: "7 Days",
  },
  {
    time: "259200",
    label: "6 Months",
  },
  {
    time: "518400",
    label: "1 Year",
  },
];

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function mapStateToProps(state) {
  return { positions: state.positions.items };
}

const getIconBackgroundColor = (position) => {
  if (!position || !position.id) {
    return "no_data";
  }

  const expiredList = globalState.userDeviceState.expired?.deviceIds || [];
  const inactiveList = globalState.userDeviceState.inactive?.deviceIds || [];

  if (expiredList.includes(position.deviceId)) {
    return "expired";
  }

  if (inactiveList.includes(position.deviceId)) {
    return "in_active";
  }

  if (position.attributes && position.attributes.motion) {
    return "running";
  }

  if (position.attributes && position.attributes.ignition) {
    return "idle";
  }

  return "stopped";
};
const useStyles = makeStyles((theme) => ({
  list: {
    maxHeight: "100%",
    overflow: "auto",
    // margin:"5%"
    paddingLeft: "15px",
    paddingRight: "15px",
    marginTop: "1.5%",
  },
  icon: {
    width: "25px",
    height: "25px",
    filter: "brightness(0) invert(1)",
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  statusGrid: {
    margin: theme.spacing(0.5),
    width: "25px",
    height: "23px",
    borderRadius: "15px",
    paddingLeft: "7px",
  },
  statusGridOn: {
    backgroundColor: "#C5E2C9",
    color: "green",
    borderRadius: "25px",
    paddingLeft: "7px",
    margin: theme.spacing(0.5),
  },
  statusGridOff: {
    backgroundColor: "#FFE9D1",
    color: "#ce5934",
    borderRadius: "25px",
    paddingLeft: "7px",
    margin: theme.spacing(0.5),
  },
  listItem: {
    marginBottom: "2%",
    boxShadow: "4px 4px 4px 4px #dbddef",
    borderRadius: "10px",

    // background:"#787868"
  },
  verticleLine: {
    height: "100%",
    width: 15,
    backgroundColor: "green",
  },
  colP: {
    margin: "0",
    textAlign: "left",
    fontSize: "10px",
  },
  value: {
    margin: "0",
    textAlign: "left",
    fontSize: "10px",
  },
  controlContent: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    width: "100%",
  },
  fabButtons: {
    width: "24px",
    height: "24px",
  },
  fabButtonsSecond: {
    maxHeight: "24px",
    minHeight: "24px",
    minWidth: "24px",
    maxWidth: "24px",
    fontSize: "1rem",
    backgroundColor: "#361DDB",
  },
}));
const globalState = {
  userDeviceState: undefined,
};
const emails = ["username@gmail.com", "user02@gmail.com"];

function SimpleDialog(props) {
  const { onClose, openData } = props;
  const { open, deviceId } = openData;
  const [commandList, setCommandList] = React.useState([]);
  const [openAlert, setOpenAlert] = React.useState({
    open: false,
    message: "",
    type: "error",
  });

  const handleClose = () => {
    onClose();
  };

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert({
      open: false,
      message: "",
      type: "",
    });
  };

  const handleListItemClick = async (value) => {
    const data = { ...value, deviceId };
    const response = await fetch("/api/commands/send", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      setOpenAlert({
        open: true,
        message: "Command Sent",
        type: "success",
      });
      setTimeout(() => {
        onClose();
      }, 1000);
    } else {
      onClose();
    }
  };

  useEffect(() => {
    async function fetchFromApi() {
      const response = await fetch(`/api/commands/send?deviceId=${deviceId}`);
      if (response.ok) {
        const resData = await response.json();
        setCommandList(resData);
      }
    }
    fetchFromApi();
  }, [deviceId]);

  return (
    <Dialog onClose={handleClose} open={open}>
      <Snackbar
        open={openAlert.open}
        autoHideDuration={2000}
        onClose={handleAlertClose}
      >
        <Alert onClose={handleAlertClose} severity={openAlert.type}>
          {openAlert.message}
        </Alert>
      </Snackbar>
      <DialogTitle>Click to Send Command</DialogTitle>
      <List sx={{ pt: 0 }}>
        {commandList.map((command) => (
          <ListItem
            button
            onClick={() => handleListItemClick(command)}
            key={command.type}
          >
            <ListItemText primary={command.description} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}

const ParkingModal = (props) => {
  const { onClose, openData } = props;
  const { open, device } = openData;
  const isparking = device.attributes?.parkingMode;

  // const [commandList, setCommandList] = React.useState([]);
  const [openAlert, setOpenAlert] = React.useState({
    open: false,
    message: "",
    type: "error",
  });

  const handleClose = () => {
    onClose();
  };

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert({
      open: false,
      message: "",
      type: "",
    });
  };

  const handleCancel = () => {
    onClose();
  };

  const handleOk = async () => {
    const url = `/api/devices/${device.id}/parkingMode?enable=${!isparking}`;
    const response = await fetch(url, {
      method: "Put",
    });

    if (response.ok) {
      setOpenAlert({
        open: true,
        message: `Parking Mode ${isparking ? "Disabled" : "Enabled"} Sent`,
        type: "success",
      });
      setTimeout(() => {
        onClose();
      }, 1000);
    } else {
      onClose();
    }
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <Snackbar
        open={openAlert.open}
        autoHideDuration={2000}
        onClose={handleAlertClose}
      >
        <Alert onClose={handleAlertClose} severity={openAlert.type}>
          {openAlert.message}
        </Alert>
      </Snackbar>
      <DialogTitle>
        {isparking ? "Disable" : "Enable"} Parking Mode ?
      </DialogTitle>
      <DialogContent dividers>
        Work only if you are eligible for it.{" "}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleOk} color="primary">
          {isparking ? "Disable" : "Enable"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const ShareLocationModal = (props) => {
  const { onClose, openData } = props;
  const { open, device } = openData;
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  const handleListItemClick = async (item) => {
    setLoading(true);
    const requestBody = {
      deviceIds: [device.id],
      time: item.time,
      attributes: {},
      id: 0,
    };
    try {
      const response = await fetch(`/api/android/getDevicesLocationShareLink`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setResponseMessage(data.message);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog width="lg" open={open} onClose={handleClose}>
      <DialogTitle>Select Time Interval For Live Location sharing</DialogTitle>
      <DialogContent>
        <List>
          {ShareLocationData.map((item) => (
            <ListItem
              button
              onClick={() => handleListItemClick(item)}
              key={item.time}
            >
              <ListItemText primary={item.label} />
            </ListItem>
          ))}
        </List>
        {responseMessage && (
          <Typography
            variant="body1"
            color="textPrimary"
            style={{ marginTop: 16 }}
          >
            {responseMessage}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        {loading && <CircularProgress />}
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const DeviceView = React.memo(({ updateTimestamp, onMenuClick, reSetMap }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [filteredList, setFilteredList] = React.useState([]);
  const [viewList, setViewList] = React.useState([]);
  const [hasMoreItem, setHasMoreItem] = React.useState(true);
  const [openCommand, setOpenCommand] = React.useState({
    open: false,
    deviceId: null,
  });

  const [openParking, setOpenParking] = React.useState({
    open: false,
    device: null,
  });
  const [openShareLocation, setOpenShareLocation] = React.useState({
    open: false,
    device: null,
  });

  const [showClipboardAlert, setShowClipboardAlert] = useState(false);

  const handleClickOpen = (item) => {
    setOpenCommand({ open: true, deviceId: item.id });
  };

  const handleParkingClick = (item) => {
    setOpenParking({ open: true, device: item });
  };

  const handleClosePopUp = () => {
    setOpenCommand({ open: false, deviceId: "" });
  };
  const handleCloseParking = () => {
    setOpenParking({ open: false, device: "" });
  };

  const handleOpenShareLocation = (item) => {
    setOpenShareLocation({ open: true, device: item });
  };

  const handleCloseShareLocation = () => {
    setOpenShareLocation({ open: false, device: "" });
  };

  const items = useSelector((state) => Object.values(state.devices.items));
  const operatingUser = useSelector((state) => state.session.user);
  const { attributes = {} } = operatingUser;

  const disableCommand =
    attributes["ui.disableReport"] || attributes["ui.trackingOnly"];

  const positions = useSelector((state) => state.positions.items);
  const userDeviceState = useSelector(
    (state) => state.userDeviceState.deviceState
  );
  const selectedId = useSelector((state) => {
    if (state.devices.selectedId) {
      return state.devices.selectedId;
    }
    return null;
  });

  globalState.userDeviceState = userDeviceState;

  const distanceUnit = useAttributePreference("distanceUnit");
  const speedUnit = useAttributePreference("speedUnit");
  const volumeUnit = useAttributePreference("volumeUnit");

  useEffectAsync(async () => {
    const response = await fetch("/api/devices");
    if (response.ok) {
      dispatch(devicesActions.refresh(await response.json()));
    }
  }, [updateTimestamp]);

  useEffectAsync(async () => {
    setFilteredList(items);
    if (items.length <= 10) {
      setViewList(items);
    } else {
      setViewList(items.slice(0, 10));
    }
  }, [items.length]);

  const getAddress = (position) => {
    const attributes = position.attributes || {};
    return (
      <React.Fragment>
        <label
          style={{
            color: "#4D5C69",
            borderRadius: 3,
            paddingRight: 5,
            fontSize: 12,
          }}
        >
          {position.address || "No Data"}
        </label>
        <Grid container style={{ marginTop: "10px" }}>
          <Grid item xs={4}>
            {/* <Paper className={classes.paper}> */}

            <div
              className={classes.value}
              style={{ color: "#6C6C6C", fontSize: "6" }}
            >
              <b>{formatDurationTime(attributes.todayRunningTime)}</b>
            </div>
            <div className={classes.colP}>{t("todayRunningTime")}</div>
          </Grid>
          <Grid item xs={4}>
            <div className={classes.value}>
              <b> {formatDurationTime(attributes.todayStoppedTime)}</b>
            </div>
            <div className={classes.colP}>{t("todayStoppedTime")}</div>
          </Grid>
          <Grid item xs={4}>
            <div className={classes.value}>
              <b>{formatDurationTime(attributes.todayIdleTime)}</b>
            </div>
            <div className={classes.colP}>{t("todayIdleTime")}</div>
          </Grid>
        </Grid>
        <div style={{ fontSize: 12 }}>
          {formatDate(position.serverTime, "LLL")}
        </div>
        <div>
          {attributes.ignition != "undefined" && (
            <Chip
              label={attributes.ignition}
              icon={<VpnKeyIcon />}
              className={
                attributes.ignition
                  ? classes.statusGridOn
                  : classes.statusGridOff
              }
              size="small"
              color="secondary"
            />
          )}
          {attributes.charge != "undefined" && (
            <Chip
              label={attributes.charge}
              icon={<BatteryStdIcon />}
              size="small"
              color="secondary"
              className={
                attributes.charge ? classes.statusGridOn : classes.statusGridOff
              }
            />
          )}
          {attributes.ac != "undefined" && (
            <Chip
              label={attributes.ac}
              icon={<AcUnitIcon />}
              size="small"
              color="secondary"
              className={
                attributes.ac ? classes.statusGridOn : classes.statusGridOff
              }
            />
          )}
          {attributes.door != "undefined" && (
            <Chip
              label={attributes.door}
              icon={<MeetingRoomIcon />}
              size="small"
              color="secondary"
              className={
                attributes.door ? classes.statusGridOn : classes.statusGridOff
              }
            />
          )}
          {attributes.blocked != "undefined" && (
            <Chip
              label={attributes.blocked}
              icon={<LockIcon />}
              size="small"
              color="secondary"
              className={
                !attributes.blocked
                  ? classes.statusGridOn
                  : classes.statusGridOff
              }
            />
          )}
        </div>
      </React.Fragment>
    );
    // return itemData.address || "No Data"
  };

  const getPositionStatusValues = (itemData) => {
    const attributes = itemData.attributes || {};
    return (
      <React.Fragment>
        <Chip
          label={
            itemData.speed
              ? formatSpeed(itemData.speed, speedUnit)
              : formatSpeed(0, speedUnit)
          }
          icon={<SpeedIcon />}
          className={classes.chip}
          size="small"
          color="secondary"
          style={{
            backgroundColor: "#EFEBFC",
            color: "#623DE6",
            borderRadius: 3,
            marginLeft: "-20px",
            marginTop: "10px",
          }}
        />
      </React.Fragment>
    );
    // return itemData.address || "No Data"
  };

  const getPosition = (id) => {
    const itemData = positions[id] || {};
    const attributes = itemData.attributes || {};
    return itemData;
  };

  const changeMapType = (value = "ROUTE_PLAY") => {
    dispatch(mapStateTypesActions.addState(value));
  };

  const getPrimaryText = (item, itemData) => {
    const attributes = itemData.attributes || {};

    // const classes = useStyles();
    return (
      <React.Fragment>
        <label
          style={{
            color: "black",
            borderRadius: 3,
            paddingRight: 5,
            fontSize: 14,
          }}
        >
          {item.name}
        </label>
        {item.attributes.driverName && (
          <Chip
            label={item.attributes.driverName}
            icon={<FaceIcon />}
            // onDelete={data.label === 'React' ? undefined : handleDelete(data)}
            className={classes.chip}
            size="small"
            color="secondary"
            style={{
              backgroundColor: "#FFF2E6",
              color: "#FF7D17",
              borderRadius: 3,
            }}
          />
        )}
        <Chip
          label={
            attributes.todayDistance
              ? formatDistance(attributes.todayDistance, distanceUnit)
              : formatDistance(0, distanceUnit)
          }
          icon={<DriveEtaIcon />}
          className={classes.chip}
          size="small"
          color="secondary"
          style={{
            backgroundColor: "#EFEBFC",
            color: "#623DE6",
            borderRadius: 3,
          }}
        />
      </React.Fragment>
    );
  };
  const updateFilter = (value) => {
    const sarchValue = (value.search && value.search.split(",")) || null;
    const filterID =
      (value.filter &&
        globalState.userDeviceState[value.filter]["deviceIds"]) ||
      globalState.userDeviceState.totalDevices.deviceIds;

    const filteredListData = items.filter((item) =>
      value.search
        ? filterID.includes(item.id) &&
          sarchValue &&
          sarchValue.some((sValue) => item.name.toLowerCase().includes(sValue))
        : // item.name.toLowerCase().includes(value.search)
          filterID.includes(item.id)
    );
    setHasMoreItem(true);
    setFilteredList(filteredListData);

    if (filteredListData.length <= 10) {
      setViewList(filteredListData);
    } else {
      setViewList(filteredListData.slice(0, 10));
    }
  };
  const pieSliceClicked = ({ sliceKey }) => {
    updateFilter({ search: "", filter: sliceKey });
  };

  const loadMoreList = () => {
    const filterLength = viewList.length;
    let nextUpto = filterLength + 10;
    if (viewList.length === filteredList.length) {
      setHasMoreItem(false);
      return;
    }
    // setHasMoreItem(true);

    if (nextUpto > filteredList.length) {
      nextUpto = filteredList.length;
    }

    setTimeout(() => {
      setViewList(viewList.concat(filteredList.slice(filterLength, nextUpto)));
    }, 1000);
  };

  const handleClipboardAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShowClipboardAlert(false);
  };

  return (
    <>
      {openCommand.open && (
        <SimpleDialog openData={openCommand} onClose={handleClosePopUp} />
      )}
      {openParking.open && (
        <ParkingModal openData={openParking} onClose={handleCloseParking} />
      )}
      {openShareLocation.open && (
        <ShareLocationModal
          openData={openShareLocation}
          onClose={handleCloseShareLocation}
        />
      )}
      <Snackbar
        open={showClipboardAlert}
        autoHideDuration={1500}
        onClose={handleClipboardAlertClose}
      >
        <Alert onClose={handleClipboardAlertClose} severity={"success"}>
          Address copied to clipboard successfuly !!
        </Alert>
      </Snackbar>
      <ChartComp pieSliceClicked={pieSliceClicked} />
      <FilterListView updateFilter={updateFilter} reSetMap={reSetMap} />
      <List className={classes.list}>
        {(!viewList || viewList.length === 0) && (
          <div
            style={{
              width: "100%",
              border: "1px solid #dfdfdf",
              textAlign: "center",
            }}
          >
            <h2>No vehicle found</h2>{" "}
          </div>
        )}

        {viewList && viewList.length > 0 && (
          <InfiniteScroll
            pageStart={0}
            // initialLoad= {true}
            loadMore={loadMoreList}
            hasMore={hasMoreItem}
            loader={
              <div className="loader" key={0}>
                Loading ...
              </div>
            }
            useWindow={false}
          >
            {viewList.map((item, index, list) => {
              const position = getPosition(item.id);
              return (
                <Fragment key={item.id}>
                  <ListItem
                    button
                    key={item.id}
                    onClick={() => {
                      dispatch(devicesActions.select(item));
                      changeMapType("Device_Selected");
                    }}
                    className={classes.listItem}
                    style={{
                      background: selectedId == item.id ? "#dcecf9" : "#fff",
                    }}
                  >
                    <Divider
                      style={{
                        backgroundColor: "green",
                        color: "#623DE6",
                        width: 20,
                      }}
                      orientation="vertical"
                    ></Divider>
                    <div style={{ verticalAlign: "middle" }}>
                      <div
                        style={{
                          borderRadius: "50%",
                          width: "80px",
                          marginLeft: "-21px",
                        }}
                      >
                        <img
                          width={"100%"}
                          src={`images/category/category_${
                            item.category || "car"
                          }_${getIconBackgroundColor(position)}.png`}
                          alt=""
                        />
                      </div>
                      {getPositionStatusValues(position)}
                    </div>
                    <ListItemText
                      primary={getPrimaryText(item, position)}
                      secondary={getAddress(position)}
                    />

                    <div
                      style={{
                        width: "48px",
                        top: "auto",
                        display: "row",
                        height: "100%",
                        textAlign: "end",
                      }}
                    >
                      <Grid container>
                        <Grid item xs={12}>
                          <Fab
                            size="small"
                            color="primary"
                            aria-label="play"
                            onClick={(e) => {
                              e.stopPropagation();
                              dispatch(devicesActions.select(item));
                              changeMapType("ROUTE_PLAY");
                            }}
                            className={classes.fabButtonsSecond}
                          >
                            <PlayArrowIcon
                              style={{
                                color: "white",
                                width: "16px",
                                height: "16px",
                              }}
                            />
                          </Fab>
                        </Grid>
                        <Grid item xs={12}>
                          <Fab
                            size="small"
                            color="primary"
                            aria-label="copy"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenShareLocation(item);

                              // const addressToCopy = position.address
                              //   ? position.address
                              //   : "No Data";
                              // navigator.clipboard.writeText(addressToCopy);
                              // setShowClipboardAlert(true);
                            }}
                            style={{ marginTop: "12px" }}
                            className={classes.fabButtonsSecond}
                          >
                            <ShareIcon
                              style={{ width: "16px", height: "16px" }}
                            />
                          </Fab>
                        </Grid>
                        <Grid item xs={12}>
                          {!disableCommand && (
                            <Fab
                              size="small"
                              color="primary"
                              aria-label="copy"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleClickOpen(item);
                                // const addressToCopy = position.address
                                //   ? position.address
                                //   : "No Data";
                                // navigator.clipboard.writeText(addressToCopy);
                              }}
                              style={{ marginTop: "12px" }}
                              className={classes.fabButtonsSecond}
                            >
                              <LockIcon
                                style={{ width: "16px", height: "16px" }}
                              />
                            </Fab>
                          )}
                        </Grid>
                        <Grid item xs={12}>
                          <Fab
                            size="small"
                            color="primary"
                            aria-label="copy"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleParkingClick(item);
                            }}
                            style={{ marginTop: "12px" }}
                            className={classes.fabButtonsSecond}
                          >
                            <LocalParkingIcon
                              style={{ width: "16px", height: "16px" }}
                            />
                          </Fab>
                        </Grid>
                        {/* <Grid item xs={12}>
                  <Fab
                    size="small"
                    color="primary"
                    aria-label="send"
                    style={{ marginTop: "12px" }}
                    className={classes.fabButtonsSecond}
                  >
                    <SendIcon style={{ width: "16px", height: "16px" }} />
                  </Fab>
                </Grid> */}
                      </Grid>
                    </div>
                    {/* <ListItemSecondaryAction>
                    <IconButton
                      onClick={(event) => onMenuClick(event.currentTarget, item.id)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </ListItemSecondaryAction> */}
                  </ListItem>
                </Fragment>
              );
            })}
          </InfiniteScroll>
        )}
      </List>
    </>
  );
});

const DevicesList = ({ reSetMap }) => {
  return (
    <HomeCollectionViewMt
      content={DeviceView}
      editPath="/device"
      endpoint="devices"
      reSetMap={reSetMap}
    />
  );
};

export default DevicesList;
